
import * as React from 'react';
import './styles.scss';



const ProgressBar = (props) => {
    let currentProgressColor;
   // let currentProgress =props.percentage ;
    return (
            <div className="progress-bar">
                <div
                    className={`filler ${currentProgressColor || 'SuccessFile'}` }
                    style={{ width: `${props.percentage}%` }}
                >
                </div>
            </div>
    )
}



export default ProgressBar;
